<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <ReceptionTop />

      <div class="col-12">
        <span class="top-actions">
          <button
            type="button"
            class="mycustom-success-button"
            @click="showCreateVisitModal"
          >
            <i class="bi bi-plus-square-dotted"></i> Add Visit
          </button>
        </span>
      </div>
      <!-- -------------------------- -->

      <div class="col-12">
        <!-- table start -->
        <div class="card mb-4">
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <nav>
                <!-- <Search :PlaceHolder="placeHolderText" @search="handleSearch" /> -->
                <Search
                  :placeholder="'Srch.. name, phone, email, OPD/IPD'"
                  @onsearch="handleSearch"
                />
              </nav>
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      #visit id
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Patient
                    </th>
                    <th
                      class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                    >
                      OPD/IPD
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      In Department
                    </th>
                     <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Visit Date
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Ticket Number
                    </th>
                    <th
                      class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                    >
                      Payment Method
                    </th>

                    <th class="text-secondary opacity-7"></th>
                  </tr>
                </thead>

                <div v-if="tableLoading">
                  <div class="loader" v-if="apiLoading">
                    <div class="spinner"></div>
                    <p>Loading...</p>
                  </div>
                </div>

                <tbody v-if="users.length">
                  <tr v-for="user in users" :key="user.id">
                    <td>#{{ user.id }}</td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div></div>
                        <div class="d-flex flex-column justify-content-center">
                          <h6 style="color: black" class="mb-0 text-sm">
                            {{ user.name }}
                          </h6>

                          <p class="text-xs text-secondary mb-0">
                            {{ user.phone == null ? "" : user.phone }}
                          </p>
                          <p class="text-xs text-secondary mb-0">
                            {{ user.email == null ? "" : user.email }}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">
                        OPD/{{ user.opd == null ? "--" : user.opd }}
                      </p>
                      <p v-if="user.ipd != null " class="text-xs text-secondary mb-0">
                        IPD/{{ user.ipd == null ? "--" : user.ipd }}
                      </p>
                    </td>
                    <td class="align-middle text-sm">
                      <p class="text-xs font-weight-bold mb-0">
                        {{
                          user.department_name == null
                            ? "--"
                            : user.department_name +
                              " - " +
                              user.department_code_id
                        }}
                      </p>
                      <p class="text-xs text-secondary mb-0">
                        {{
                          user.department_description == null
                            ? "--"
                            : user.department_description
                        }}
                      </p>
                    </td>
                    <td>
                      {{ formatDateTime(user.created_at) }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      <soft-badge
                        :style="{
                          backgroundColor: 'beige',
                          color: 'black',
                          paddingLeft: '1em',
                          paddingRight: '1em',
                          borderRadius: '0.5em',
                        }"
                        color="success"
                        variant="gradient"
                        size="sm"
                      >
                        {{ user.ticket_id }}
                      </soft-badge>
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span
                        :style="
                          user.payment_method == 2
                            ? {
                                backgroundColor: 'wheat',
                                color: 'black',
                                paddingLeft: '1em',
                                paddingRight: '1em',
                                borderRadius: '0.5em',
                              }
                            : {
                                backgroundColor: '#80e5ff',
                                color: 'black',
                                paddingLeft: '1em',
                                paddingRight: '1em',
                                borderRadius: '0.5em',
                              }
                        "
                      >
                        {{
                          user.payment_method == 2
                            ? user.insurance_company == null
                              ? "Invoice"
                              : "Insurance"
                            : "Cash"
                        }}
                      </span>
                    </td>
                    <td class="align-middle">
                      <button
                        @click="showPatientDetailsmodel(user.patient_id)"
                        style="color: white; background-color: green"
                        class="btn-xs font-weight-bold text-xs"
                      >
                        View patient
                      </button>

                      <button
                        @click="show_discharge_modal(user.id)"
                        style="color: white; background-color: red"
                        class="btn p-1 m-0 btn-xs font-weight-bold text-xs"
                      >
                        Discharge patient
                      </button>
                    </td>
                  </tr>
                </tbody>
                <div v-else>
                  <p class="tocenter-container" v-if="!apiLoading">
                    No Records found.
                  </p>
                </div>
              </table>
              <!-- Pagination   @page-change="handlePageChange" :current-page="currentPage" :total-pages="totalPags" -->
              <!-- <pagination :all-data="allData" @content-change="handleContentChange" /> -->
              <div v-if="apiLoading">Loading...</div>
              <pagination
                v-if="!apiLoading"
                :all-data="allData"
                @content-change="handleContentChange"
                @loader-set="loaderSet"
              />

              <!--  -->
            </div>
          </div>
        </div>
        <!-- table end -->
        <ShowPatientModal
          v-if="showModalPatientDetailsModel"
          @close="handleClosePatientDetailsmodel"
          :patient_id="insearch_patient"
        />

        <CreateVisitModal
          v-if="showModalCreateVisit"
          @reload-content="reloadContent"
          @close="handleCloseCreateVisitmodel"
        />
        <discharge_modal
          v-if="show_discharge_mod"
          :visit_id="current_visit_id"
          @close-discharge-modal="hide_discharge_modal"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";
import Pagination from "../components/pagination.vue";
import Search from "../components/search.vue";
import ReceptionTop from "./reception_top.vue";
import ShowPatientModal from "../Patients/components/patient_details.vue";
import CreateVisitModal from "../Patients/components/create_visit.vue";
import discharge_modal from "../inpatient/discharge_modal.vue";
import formatDateTime from "../../timezone/utc_local_time";

//import axios from "axios";

export default {
  name: "patientsindex",
  data() {
    return {
      show_discharge_mod: false,
      current_visit_id: "",
      insearch_patient: "",
      showModalPatientDetailsModel: false,
      showModalCreateVisit: false,
      users: [],
      allData: {},
      apiLoading: true,
      tableLoading: true,
      placeHolderText: "Search name,phone,email,opd/ipd",
    };
  },
  components: {
    Pagination,
    Search,
    ReceptionTop,
    ShowPatientModal,
    CreateVisitModal,
    discharge_modal,
  },

  methods: {
    formatDateTime,
    show_discharge_modal(visit_id) {
      this.current_visit_id = visit_id;
      this.show_discharge_mod = true;
    },
    hide_discharge_modal() {
      this.current_visit_id = "";
      this.show_discharge_mod = false;
    },
    async discharge_patient(visit_id) {
      // ⚠️ Prompt the user for confirmation first
      const confirmed = window.confirm(
        "⚠️ Are you sure you want to discharge this patient?"
      );

      // ⚠️ If the user confirms, then proceed with the discharge process
      if (confirmed) {
        try {
          // Call the API function to discharge the patient
          const url = "end_visit/" + visit_id;
          await generalApiRequest(url, "GET", {}, 1);
          // Display a success message or update the UI

          alert("Patient successfully discharged!");
          window.location.reload();
        } catch (error) {
          // Handle any errors that occur during the API call
          alert("An error occurred while discharging the patient.");
          console.error(error);
        }
      } else {
        // Optionally, inform the user that the action was canceled
        alert("Discharge canceled.");
      }
    },
    async handleSearch(searchTerm) {
      //console.log("the serch rem is " +searchTerm);
      try {
        this.apiLoading = true;
        const url = "get_all_active_visits_search";
        const body = { search_param: searchTerm };

        const rs = await generalApiRequest(url, "GET", body, 1);

        this.allData = rs.data;
        this.apiLoading = false;
        console.log(this.allData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    showCreateVisitModal() {
      this.showModalCreateVisit = true;
    },
    handleCloseCreateVisitmodel() {
      this.showModalCreateVisit = false;
    },

    handleClosePatientDetailsmodel() {
      this.showModalPatientDetailsModel = false;
    },

    showPatientDetailsmodel(patient) {
      this.insearch_patient = patient;
      this.showModalPatientDetailsModel = true;
    },

    handleContentChange(contents) {
      // console.log("procceds");
      // console.log(contents);
      this.users = contents;
    },

    loaderSet(value) {
      if (value == true) {
        this.users = [];
      }
      this.tableLoading = value;
      //console.log(value);
      //this.apiLoading = value;
    },

    async callApi() {
      try {
        const url = "get_all_active_visits?page=1";
        const body = {};

        // const data = await getMethodRequest(url, body, 1);
        const data = await generalApiRequest(url, "GET", body, 1);
        console.log(data);
        this.allData = data.data;
        this.apiLoading = false;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
  },

  mounted() {
    this.callApi();
  },
};
</script>
